import { render, staticRenderFns } from "./CarConfiguration.vue?vue&type=template&id=5c491914"
import script from "./CarConfiguration.vue?vue&type=script&lang=js"
export * from "./CarConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports